import React from "react";
import NewHeroSection from "./NewHeroSection";
import FeaturedCollections from "./FeaturedCollections";
import TrustSection from "./TrustSection";
import TestimonialsNew from "./TestimonialsNew";
import JourneyTimeline from "./JourneyTimeline";
import DiscoverMasterpiece from "./DiscoverMasterpiece";
import JourneyVideoBanner from "./JourneyVideoBanner";
import Showrooms from "./Showrooms";

const Home = () => {
  return (
    <div className="bg-[#fdfaf5] min-h-screen">
      <NewHeroSection />
      <FeaturedCollections />
      <TrustSection />
      <TestimonialsNew />
      <JourneyTimeline />
      <DiscoverMasterpiece />
      <JourneyVideoBanner />
      <Showrooms />
    </div>
  );
};

export default Home;
